import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function FootballFill(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.217 15.5l1.243 2.071-.872 3.051A9.002 9.002 0 0112 21c-.9 0-1.768-.132-2.588-.378l-.872-3.05L9.783 15.5h4.434zm4.139-4.47l2.568 2.141A8.948 8.948 0 0119.484 17h-3.2l-1.249-2.08.87-3.48 2.451-.41zm-12.712 0l2.45.41.87 3.48-1.225 2.043-3.521-.44a8.941 8.941 0 01-1.142-3.352l2.568-2.14zm2.988-7.379l2.868 1.64v2.952l-3.122 2.23-2.526-.421-1.32-3.078a9.031 9.031 0 014.1-3.323zm6.736 0a9.03 9.03 0 013.983 3.155l-1.218 3.248-2.51.419-3.123-2.23V5.29l2.868-1.639zm5.098 3.024A9.993 9.993 0 0012 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10a9.953 9.953 0 00-1.533-5.322l-.001-.003z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(FootballFill);
export default ForwardRef;